import Vue from "vue";
import Vuex from "vuex";
import app from "./modulos/app";

import MenuParametrizacaoIncludes from "@/components/Parametrizacao/Menu/Store/Includes";

import snackbar from "./modulos/snackbar";
import fornecedor from "./modulos/fornecedor";
import usuario from "./modulos/usuario";
import loading from "./modulos/loading";
import loadingAux from "./modulos/loadingAuxiliar";
import tabela from "./modulos/tabela_dashboard";
import chart_fornecedor from "./modulos/chart_fornecedor";
import tabela_compra from "./modulos/tabela_compra";
import detalhe_produto from "./modulos/detalhe_produto";
import notificacaoProdutoSilenciado from "./notificacaoProdutoSilenciado";
import notificacao from "./notificacao";
import wkfItem from "./workflow/item";
import wkfAutorizacao from "./workflow/autorizacao";
import wkfControleGrupo from "./workflow/controlegrupo";
import activityLog from "./activityLog/activityLog";
import produtoFracionado from "./produtoFracionado";
import pedidoFracionado from "./pedidoFracionado";
import carrinho from "./carrinho";
import relatorio from "./relatorio";
import chartRaioX from "./charts/raio-x-produto";
import tabelaProduto from "./compra/TabelaProdutos";
import orcFornecedor from "./orcamento/fornecedor";
import orcComprador from "./orcamento/comprador";
import configuracoes from "./configuracoes/carrinho";
import evento from "./evento";
import drpProduto from "./drp/produto";
import drpBlacklist from "./drp/blacklist";
import segmentosCompra from "./compra/Segmentos";
import linhasCompra from "./compra/Linhas.js";
import MarcasCompra from "./compra/Marcas";
import EmbalagemTelaDeCompras from "./compra/EmbalagemTelaDeCompras";
import ProdutosSelecionados from "./compra/ProdutosSelecionados";
import carrinhoDepartamentos from "./carrinho/CarrinhoDepartamentos";
import comprasPorDepartamentos from "./compra/Departamentos.js";
import loading_geral from "./loading/loadingDataTableDepartamentos.js";
import compraMateriaPrima from "./compra/MateriaPrima.js";
import CompraDistribuidaPorFilial from "./compra/CompraDistribuidaPorFilial.js";
import filtrosProdutos from "./compra/FiltrosProdutos.js";
import filtrosProdutosDiagnostico from "./Diagnostico/FiltrosProdutos.js";
import filtrosUniversalAvancado from "./filtros/FiltrosUniversalAvancado";
import CompraProdutosGerais from "./compra/CompraProdutosGerais.js";
import ExportacaoPedidoCompraParaERP from "./compra/ExportacaoPedidoCompraParaERP.js";
import CotacaoCarrinhoCompra from "@/components/compra/carrinho/Cotacao/CotacaoStore";
import WebSocket from "@/store/WebSocket";
import ProdutosCombinados from '@/store/compra/ProdutosCombinados.js';
import diagnosticoAnaliseQualitativaEstoque from "./Diagnostico/AnaliseQualitativaEstoque.js";
import EventoSazonalFinal from '@/components/Eventos/store/sazonalidade.js';
import ChatSuporte from "./ChatSuporte.js";
import filtrosDrpPainel from "@/store/Diagnostico/Drp/filtrosDrpPainel";

Vue.use(Vuex);

export default new Vuex.Store({
  namespaced: true,
  modules: {
    app,
    MenuParametrizacaoIncludes,
    notificacaoProdutoSilenciado,
    notificacao,
    snackbar,
    fornecedor,
    usuario,
    loading,
    loadingAux,
    tabela,
    chart_fornecedor,
    tabela_compra,
    detalhe_produto,
    wkfItem,
    wkfAutorizacao,
    wkfControleGrupo,
    activityLog,
    produtoFracionado,
    pedidoFracionado,
    carrinho,
    relatorio,
    chartRaioX,
    tabelaProduto,
    orcFornecedor,
    orcComprador,
    configuracoes,
    evento,
    drpProduto,
    drpBlacklist,
    segmentosCompra,
    linhasCompra,
    EmbalagemTelaDeCompras,
    ProdutosSelecionados,
    carrinhoDepartamentos,
    comprasPorDepartamentos,
    loading_geral,
    compraMateriaPrima,
    CompraDistribuidaPorFilial,
    filtrosProdutos,
    filtrosProdutosDiagnostico,
    filtrosUniversalAvancado,
    CompraProdutosGerais,
    ExportacaoPedidoCompraParaERP,
    CotacaoCarrinhoCompra,
    WebSocket,
    ProdutosCombinados,
    diagnosticoAnaliseQualitativaEstoque,
    EventoSazonalFinal,
    ChatSuporte,
    filtrosDrpPainel,
    MarcasCompra,
  }
});
